import React, { useRef, useState } from 'react';

import "assets/scss/billingPortal/modules/reporting/invoiceCommission.scss";
import DrillDownReport from './reportTypes/DrillDownReport';
import MainReport from './reportTypes/MainReport';

export default function CreditNoteCommission() {
    const [isDrillDownReportVisible, setIsDrillDownReportVisible] = useState();
    const [selectedDealerDrillDown, setSelectedDealerDrillDown] = useState();

    const queries = useRef({});

    return (
        <div>
            {isDrillDownReportVisible && (
            <div className={isDrillDownReportVisible? "":"d-none"}>
                <DrillDownReport queries={queries}
                    isDrillDownReportVisible={isDrillDownReportVisible}
                    setIsDrillDownReportVisible={setIsDrillDownReportVisible}
                    selectedDealerDrillDown={selectedDealerDrillDown}
                    setSelectedDealerDrillDown={setSelectedDealerDrillDown}
                />
            </div>
            )}

            <div className={isDrillDownReportVisible? "d-none":""}>
                <MainReport queries={queries}
                    setIsDrillDownReportVisible={setIsDrillDownReportVisible}
                    setSelectedDealerDrillDown={setSelectedDealerDrillDown}
                />
            </div>
        </div>
    );
}